module.exports = __webpack_public_path__ + "static/don41-50df79b23d74d252c471a0600832f451.jpg";